module.exports = __webpack_public_path__ + "img/faq2.6b7bf214.png";